import i18n from 'i18next';

void i18n.init({
  fallbackLng: 'en-US',
});

export default i18n;
